(ns dashboard.notifications
  (:require [re-frame.core :as rf]
            [dashboard.effects :as effects]))

(rf/reg-event-fx
  ::add
  (fn [{:keys [db]} [_ notif]]
    (let [max-notifs 5
          new-notif  (merge notif {:id (random-uuid)})
          new-items  (take max-notifs
                                 (conj (-> db :notifications :items)
                                       new-notif))]
      {:db                  (assoc-in db [:notifications :items] new-items)
       ::effects/fx-timeout {:timeout    (* 5 1000)
                             :timeout-fn #(rf/dispatch [::remove new-notif])}})))

(rf/reg-event-db
  ::remove
  (fn [db [_ {:keys [id]}]]
    (assoc-in db [:notifications :items]
              (->> db
                   :notifications
                   :items
                   (remove #(= id (:id %)))))))

(comment

  (rf/dispatch [::add {:message (str (random-uuid))}])

  (rf/dispatch [::remove {:id #uuid "c376ec41-f413-4089-9767-5dcfd38b2a48"}]))
